const ID_PLACEHOLDER = '{ID}';
const REST_ENDPOINTS = {
    APPLICATIONS_REST: 'applications',
    POLICY_REST: 'policies',
    CREDENTIALS_REST: 'credentials',
    SUBSCRIPTIONS_REST: 'subscriptions',
    AUTHORITIES_REST: 'authorities',
    TASKS_REST: 'tasks',
    TARGET_ENDPOINT: 'targets',
    TARGET_ENDPOINT_FLR: 'storageAccounts',
    VMS_REST: 'virtualMachines',
    DASHBOARDS_REST: 'dashboard',
    EVENTS_REST: 'events',
    EVENTS_CATEGORIES_REST: 'events/categories',
    POLICIES_REST: 'policies',
    BACKUP_REST: 'system',
    BACKUPS_WIDGET_REST: 'backups',
    RECOVER_VERSION_REST: `vms/${ID_PLACEHOLDER}/backups`,
    RESOURCE_GROUP_REST: 'resourceGroups',
    RESTORE_REST: 'vms/restore',
    EXPORT_VM_REST: 'vms/export',
    EXPORT_APP_REST: 'applications/export',
    SELFSERVICE_REST: 'selfservice',
    BACKUP_WINDOW_REST: 'backupWindows',
    SNAPSHOT: 'snapshots',
    ARCHIVING_REST: 'archives',
    PROTECTION_SETS_REST: 'protectionSets',
    SCOPE_REST: 'scope',
    REPORTS_REST: 'reports',
    IAM_REST: 'iam',
};
REST_ENDPOINTS.CREDENTIALS_APP_ASSIGN_REST = `${REST_ENDPOINTS.CREDENTIALS_REST}/app/assign`;
REST_ENDPOINTS.CREDENTIALS_APP_UNASSIGN_REST = `${REST_ENDPOINTS.CREDENTIALS_REST}/app/unassign`;
REST_ENDPOINTS.USERS_ROLES_REST = `${REST_ENDPOINTS.AUTHORITIES_REST}/roles`;

class SharedPersistenceService {
    constructor(crudService) {
        this._crudService = crudService;
        this.clusterRenderCounter = 0;
    }

    getRestEndpoints() {
        return REST_ENDPOINTS;
    }

    assignPolicy(policy, payload) {
        return this._crudService.post(`${REST_ENDPOINTS.POLICY_REST}/${encodeURI(policy.uuid)}/assign`, payload);
    }

    unassignPolicy(policy, payload) {
        return this._crudService.post(`${REST_ENDPOINTS.POLICY_REST}/unassign`, payload);
    }

    getTargets() {
        return this._crudService.get(REST_ENDPOINTS.TARGET_ENDPOINT)
            .then(res => {
                return res.data.entities.map(item => { return Target.fromRaw(item); });
            });
    }

    getProtectionSets() {
        return this._crudService.get(REST_ENDPOINTS.PROTECTION_SETS_REST, false, false, false, false, false, false, true).then(res => {
            return res.data.entities;
        });
    }

    getAllVmAdminAuthorities() {
        return this._crudService.get(REST_ENDPOINTS.AUTHORITIES_REST + '/dropDown', null, null, null, null, false, false, true).then(res => {
            let authorities = res.data.entities;
            return authorities;
        });
    }

    expireBackup(backupUuid, selectedTiers) {
        return this._crudService.post('backups/' + backupUuid + '/expire', selectedTiers);
    }

}

SharedPersistenceService.$inject = ['crudService'];

module.exports = SharedPersistenceService;


// WEBPACK FOOTER //
// ./src/azurebackup/services/shared.persistence.service.js